<template>
  <div class="boxItem">
    <div id="minBox"></div>
    <div id="Box">
      <div class="bg_Blur"></div>
      <div class="f1" v-for="(item, index) in verify" :style="item.divStyle" @click="radioAdd">
        <span :style="item.spanStyle" @click="clickSpan(item)">{{ item.text }}</span>
      </div>
      <div class="radio" v-for="(item, index) in radio" :style="item.style" @click="radioClick(index)">{{ index + 1 }}</div>
    </div>
    <div class="panel">
      <div class="geetest_small" style="outline: none; font-size: 12px;">
        <a class="geetest_close iconfont icon-guanbi" @click="closeVer">
          <div class="geetest_close_tip">关闭验证</div>
        </a>
        <a class="geetest_refresh iconfont icon-huanyihuan" @click="init">
          <div class="geetest_refresh_tip">刷新验证</div>
        </a>
        <span style="color: #e62d26;vertical-align: top;margin-left: 5px;" v-if="errorShow">
          验证失败，请根据提示重新验证
        </span>
      </div>
      <a class="geetest_commit" @click="enterVer">
        <div class="geetest_commit_tip">确认</div>
      </a></div>
  </div>

</template>

<script>
import $ from 'jquery'

export default {
  name: "verificationText",
  data() {
    return {
      verify: [],
      radio: [],
      clickS: [],
      errorShow: false,
    }
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      //随机词汇表
      let arr = ["新春快乐", "君子不器", "恭贺新禧", "万事如意", "张灯结彩",
        "恭喜发财", "假期愉快", "麟凤龟龙", "涅而不缁", "淑人君子",
        "爱才若渴", "一见倾心", "琴挑文君", "坐上琴心", "琴心相挑",
        "炙鸡絮酒", "猛志常在", "志存高远", "福如东海", "寿比南山"];

      //创建随机成语
      let math = arr[Math.round(Math.random() * (arr.length - 1))];
      $('#minBox').html(`请依次点击: <span style="color: #00AEEC;">${math}</span>`)

      //创建一个位置数组
      let place = [{left: '10px', top: '10px'},
        {left: '200px', top: '10px'},
        {left: '10px', top: '100px'},
        {left: '200px', top: '100px'}]

      //创建一个位置数组
      let rotate = [0, 60, 90, 45, 135, 180, 210, 260, 300, 325]

      let color = ['#fff', '#0aaaaa', '#c52a2a', '#7043b2',
        '#66af55', '#0b1a62', '#e1af43', '#c71cbe']
      let shadow = [
        '#b44b4b', '#2e5e5e', '#efc21c', '#e67026',
        '#38e80f', '#1036ec', '#867817', '#ef07e3'
      ]

      //随机打乱位置数组
      place.sort(() => {
        return Math.random() - 0.5
      })
      rotate.sort(() => {
        return Math.random() - 0.5
      })
      color.sort(() => {
        return Math.random() - 0.5
      })
      shadow.sort(() => {
        return Math.random() - 0.5
      })

      //创建一个数组用于与最终结果验证
      let verify = []
      //遍历随机成语并创建标签
      for (let i in math) {

        // verify.push(i)

        //push()方法可向数组的末尾添加一个或多个元素，并返回新的长度

        //创建随机左边位置
        let left = Math.round(Math.random() * (150))
        let top = Math.round(Math.random() * (50));

        //console.log(Math.round(Math.random() * (150)))

        //Math.round() 四舍五入
        let item = {}
        item.divStyle = {
          left: place[i].left,
          top: place[i].top
        }

        item.spanStyle = {
          left: left + 'px',
          top: top + 'px',
          transform: 'rotate('+ rotate[i]+'deg)',
          'text-shadow': `0 0 1px currentColor, -1px -1px 1px `+ shadow[i] + `, 0 -1px 1px ` + shadow[i] + `, 1px -1px 1px ` + shadow[i] + `, 1px 0 1px ` + shadow[i] + `, 1px 1px 1px ` + shadow[i] + `, 0 1px 1px ` + shadow[i] + `, -1px 1px 1px ` + shadow[i] + `, -1px 0 1px ` + shadow[i],
          color: color[i],

      }
        item.judge = true
        item.index = i
        item.text = math[i]

        verify.push(item)

        // //创建存放span的div对象
        // let divs = $('<div class="fl"></div>')
        // //给div定位
        // divs.css({
        //   left: place[i].left,
        //   top: place[i].top
        // })
        // //创建储存文字的span标签
        // let span = $(`<span>${math[i]}</span>`)
        // //随机span的位置
        // span.css({
        //   left: left + 'px',
        //   top: top + 'px'
        // })
        //
        // span.data('index', i);
        // span.data('judge', 'true');
        // divs.append(span);
        // $('#Box').append(divs)
      }
      this.verify = verify
      this.radio = []
      this.clickS = []
      this.errorShow = false
    },
    clickSpan(item) {
      this.clickS.push(item.index)
      // if (item.judge) {
      //   item.judge = false
      //   this.clickS.push(item.index)
      // } else {
      //   // this.$message.warning('重复点击')
      // }
      // if ($(this).data('judge') == 'true') {
      //
      //   clickS.push($(this).data('index'))
      //
      //   $(this).data('judge', 'false')
      //
      //   console.log(clickS)//获取的数组的位置
      //
      //
      //
      // } else {
      //
      //   alert('重复点击')
      //
      // }
    },
    radioAdd(event) {
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      console.log(event.x, (width-440)/2)
      this.radio.push({
        style: {
          left: event.x - (width-400)/2 - 12 + 'px',//设置盒子的点击事件生成小圆点的位置
          top: event.y - (height-200)/2 + 12 + 'px'
        }
      })
    },
    radioClick(index){
      this.radio.splice(index)
      this.clickS.splice(index)
    },
    closeVer(){
      this.$parent.errorNum--
      this.$parent.showVerification=false
    },
    enterVer(){
      if(this.clickS.join('')==='0123'){
        console.log('success')
        this.$parent.showVerification=false
      }else {
        this.errorShow=true
        setTimeout(()=>{
          this.errorShow = false
          this.init()
        }, 1000)
      }
    }

  }
}
</script>

<style scoped>
.boxItem {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 5px;
  background-color: white;
}
#minBox {
  margin-bottom: 10px;
}

#Box {
  width: 400px;
  height: 200px;
  /*margin: 50px auto 0;*/
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #200202;
  position: relative;
  transition: all 2s;
  border-radius: 10px;
}

#Box .f1 {
  width: 190px;
  height: 90px;
  position: absolute;
}

#Box span {
  position: absolute;
  font-size: 40px;
  transform: rotate(60deg);
  color: #def;
  text-shadow: 0 0 1px currentColor, -1px -1px 1px #000, 0 -1px 1px #000, 1px -1px 1px #000, 1px 0 1px #000, 1px 1px 1px #000, 0 1px 1px #000, -1px 1px 1px #000, -1px 0 1px #000;
}

#Box .radio {
  background-color: #00a6e7;
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  color: white;
  border: solid 2px #ffffff;
}

@keyframes Glow {
  from {
    text-shadow: 0 0 10px #fff,
    0 0 20px #C71585;
  }
  to {
    text-shadow: 0 0 5px #fff,
    0 0 10px #C71585;
  }
}

.bg_Blur {
  /*background-image: url("../assets/image/logo.jpg");*/
  width: 100%;
  height: 100%;
  background-size: cover;
  filter: blur(5px);
  background-color: #000000;
}

.size {

  color: #0480BE;

  animation: Alow 1.5s ease infinite alternate;

}

@keyframes Alow { /*验证成功文字的高光效果*/

  from {

    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #00FA9A, 0 0 70px #00FA9A, 0 0 80px #00FA9A, 0 0 100px #00FA9A, 0 0 150px #00FA9A;
  }

  to {

    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #00FA9A, 0 0 70px #00FA9A, 0 0 80px #00FA9A, 0 0 100px #00FA9A, 0 0 150px #00FA9A;
  }

}

.panel {
  position: relative;
  height: 0;
  width: 100%;
  padding-bottom: 63px;
  display: block;
  margin-top: 5px;
}
.panel .geetest_small {
  position: absolute;
  top: 50%;
  left: 4.3%;
  margin-top: -11.5px;
  height: 20px;
}
.panel .geetest_small a {
  position: relative;
  display: inline-block;
  height: 20px;
  font-size: 18px;
}
.panel .geetest_commit {
  display: block;
  position: absolute;
  border-radius: 2px;
  background-color: #539ffe;
  top: 10%;
  right: 2%;
  height: 40px;
  width: 35%;
  text-decoration: none;
  cursor: pointer;
}
.panel .geetest_commit .geetest_commit_tip {
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -10px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 2px;
  color: white;
}
.panel .geetest_close_tip, .panel .geetest_refresh_tip {
  position: absolute;
  top: -32px;
  left: 10px;
  border-radius: 2px;
  padding: 0 4px;
  height: 22px;
  min-width: 50px;
  line-height: 22px;
  background-color: #5F5F5F;
  white-space: nowrap;
  font-size: 12px;
  text-align: center;
  color: white;
  display: none;
}
.panel .geetest_close:hover .geetest_close_tip, .panel .geetest_refresh:hover .geetest_refresh_tip{
  display: block;
}
.panel .geetest_close_tip:before, .panel .geetest_refresh_tip:before {
  display: block;
  position: absolute;
  bottom: -6px;
  left: 0;
  content: '';
  border-style: solid;
  border-width: 4px 6px;
  border-color: #5F5F5F transparent transparent #5F5F5F;
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/verificationText.vue